// extracted by mini-css-extract-plugin
export var typeLarge = "Layout-module--type-large--Zmvjb";
export var typeMedium = "Layout-module--type-medium--Yd6K+";
export var typeBody = "Layout-module--type-body--p6IT3";
export var homeIcon = "Layout-module--home-icon--dTfks";
export var main = "Layout-module--main--WAyqQ";